import { memo } from 'react'
import { Box } from '@mui/material'
import { Position } from '../../proto/generated/position'
import PositionsTable from './positionsTable'
import { EmptyState, GhostRows } from '../common/EmptyState'
import ListSkeleton from '../common/ListSkeleton'

export type PositionsTableScrollAreaProps = {
    positions: Position[]
    showGreeks: boolean
    /** False until the first positions payload arrives; shows a skeleton instead of the empty state. */
    loaded?: boolean
}

const PositionsTableScrollArea: React.FC<PositionsTableScrollAreaProps> = ({ positions, showGreeks, loaded = true }) => {
    if (!loaded) {
        return <ListSkeleton variant="positions" />
    }

    if (positions.length === 0) {
        return (
            <EmptyState
                preview={<GhostRows variant="positions" />}
                text="Your intraday and carry-forward positions will appear here."
            />
        )
    }

    return (
        <Box sx={{ overflowX: 'auto', width: '100%', height: '100%' }}>
            <PositionsTable positions={positions} showGreeks={showGreeks} />
        </Box>
    )
}

export default memo(
    PositionsTableScrollArea,
    (prev, next) => prev.positions === next.positions && prev.showGreeks === next.showGreeks && prev.loaded === next.loaded
)
